import React from 'react';
import { useList } from "@pankod/refine-core";
import { Tabs } from 'antd';
import { useMe } from "context/MeContext";
import "../adminDashboard.scoped.scss";
import HraResponsesChart from "../Charts/hra-responses-chart"
import { css } from '@emotion/react';
const { TabPane } = Tabs;

export const HraResponses: React.FC = () => {
  const { company, isSuperAdmin } = useMe();
  // const {data: dataMedianWellnessScore} = useList({
  //   resource: "agg-scores",
  //   config: {
  //     filters: [
  //       {
  //         field: "employee_code",
  //         operator: "eq",
  //         value: company?.code
  //       }
  //     ]
  //   }
  // })
  // const medianWellnessScore = dataMedianWellnessScore?.data
  // const lastMedianScore = medianWellnessScore?.length
  // ? medianWellnessScore[medianWellnessScore.length - 1]?.median_score
  // : undefined;
  //console.log(lastMedianScore);
  return (
    <div className='tab tab1' css={css`
        .recharts-wrapper {
          margin: auto !important;
          align-items: center;
        }
      `}>
      {/* <h1>COMPANY WELLNESS</h1> */}
      <div className="" style={{ width: '100%'}}>
        <div className="">
          <div className='single-box'>
            {/* <h2 className='no-padding'>Scoring by Dimension</h2> */}
            <HraResponsesChart />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HraResponses;
